import { render, staticRenderFns } from "./comp_dpc-EcomodicoProductsBoard.vue?vue&type=template&id=4faebc77&scoped=true"
import script from "./comp_dpc-EcomodicoProductsBoard.vue?vue&type=script&lang=js"
export * from "./comp_dpc-EcomodicoProductsBoard.vue?vue&type=script&lang=js"
import style0 from "./comp_dpc-EcomodicoProductsBoard.vue?vue&type=style&index=0&id=4faebc77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faebc77",
  null
  
)

export default component.exports